<template>
    <v-dialog :value="value" max-width="560" @input="closeDialog">
        <v-card class="history-card">
            <v-card-title class="history-title">
                <div>
                    <div class="title-text">Histórico de atribuições</div>
                    <div class="title-subtitle">Alterações de atuante desta reserva</div>
                </div>
                <v-spacer />
                <v-btn icon @click="closeDialog">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="history-content">
                <div v-if="loading" class="text-center py-6">
                    <v-progress-circular indeterminate color="primary" />
                </div>

                <div v-else-if="entries.length === 0" class="empty-state">
                    <v-icon color="grey lighten-1" class="mb-2">mdi-history</v-icon>
                    Nenhuma atribuição registrada para esta reserva.
                </div>

                <div v-else class="history-list">
                    <div
                        v-for="entry in entries"
                        :key="entry.id"
                        class="history-entry"
                        :class="{ 'history-entry-active': entry.is_active }"
                    >
                        <div class="entry-marker">
                            <v-icon x-small color="white">mdi-account</v-icon>
                        </div>

                        <div class="entry-body">
                            <div class="entry-header">
                                <div class="entry-user">
                                    {{ entry.assigned_user ? entry.assigned_user.name : 'Usuário removido' }}
                                </div>
                                <v-chip
                                    v-if="entry.is_active"
                                    x-small
                                    color="green lighten-5"
                                    text-color="green darken-2"
                                    class="active-chip"
                                >
                                    atual
                                </v-chip>
                            </div>

                            <div class="entry-line">
                                Atribuído por
                                <strong>{{ entry.assigned_by ? entry.assigned_by.name : '—' }}</strong>
                                em {{ formatDateTime(entry.assigned_at) }}
                            </div>

                            <div v-if="entry.unassigned_at" class="entry-line muted">
                                Encerrado por
                                <strong>{{ entry.unassigned_by ? entry.unassigned_by.name : '—' }}</strong>
                                em {{ formatDateTime(entry.unassigned_at) }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions class="history-actions">
                <v-spacer />
                <v-btn text @click="closeDialog">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
    name: 'BookingAssignmentHistoryDialog',

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        bookingId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            entries: [],
        };
    },

    watch: {
        value(open) {
            if (open) {
                this.fetchHistory();
            }
        },
    },

    methods: {
        async fetchHistory() {
            try {
                this.loading = true;
                const res = await axios.get(`/api/booking/${this.bookingId}/assignments`);
                this.entries = res.data && res.data.data ? res.data.data : [];
            } catch (e) {
                this.entries = [];
                this.$simpleDialog('Erro ao carregar o histórico de atribuições.', 'error');
            } finally {
                this.loading = false;
            }
        },
        formatDateTime(value) {
            if (!value) return '—';
            return moment(value).format('DD/MM/YYYY [às] HH:mm');
        },
        closeDialog() {
            this.$emit('input', false);
        },
    },
};
</script>

<style scoped>
.history-card {
    border-radius: 6px;
}

.history-title {
    padding: 18px 20px 12px;
}

.title-text {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: #1f2933;
}

.title-subtitle {
    margin-top: 2px;
    font-size: 12px;
    color: #7b8794;
}

.history-content {
    padding: 8px 20px 4px;
}

.empty-state {
    min-height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8a8a8a;
    font-size: 14px;
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.history-entry {
    display: flex;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #edf0f2;
    border-radius: 6px;
    background-color: #fff;
}

.history-entry-active {
    border-color: #c8e6c9;
    background-color: #fbfffb;
}

.entry-marker {
    width: 22px;
    height: 22px;
    margin-top: 1px;
    border-radius: 50%;
    background-color: #90a4ae;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}

.history-entry-active .entry-marker {
    background-color: #43a047;
}

.entry-body {
    min-width: 0;
    flex: 1;
}

.entry-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 3px;
}

.entry-user {
    min-width: 0;
    font-size: 14px;
    font-weight: 500;
    color: #1f2933;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.active-chip {
    flex: 0 0 auto;
    font-weight: 500;
}

.entry-line {
    font-size: 12px;
    line-height: 18px;
    color: #5f6b76;
}

.entry-line strong {
    color: #344054;
    font-weight: 500;
}

.entry-line.muted {
    color: #7b8794;
}

.history-actions {
    padding: 8px 20px 16px;
}
</style>
